import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';

import Error404 from '../containers/Error404';
import SalesTable from '../containers/sale/SalesTable';
import Sale from '../containers/sale/Sale';
import CloseBox from '../containers/sale/CloseBox';
import CurrentStock from '../containers/sale/CurrentStock';

class SaleRoute extends Component {

    render() {
        return (
            <div>
                {this.props.children}
                <Switch>
                    <Route exact path='/sale' component={SalesTable}/>
                    <Route exact path='/sale/view/:id' component={Sale}/>
                    <Route exact path='/sale/close' component={CloseBox}/>
                    <Route exact path='/sale/stock' component={CurrentStock}/>
                    <Route exact path={'*'} component={Error404}/>
                </Switch>
            </div>
        );
    }
}

export default SaleRoute;



// WEBPACK FOOTER //
// ./src/routes/SaleRoute.js